/* tslint:disable */
/* eslint-disable */
/**
 * NoRadio Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FileUrl } from './FileUrl';
import { FileUrlFromJSON, FileUrlFromJSONTyped, FileUrlToJSON } from './FileUrl';
import type { ProjectModel } from './ProjectModel';
import {
    ProjectModelFromJSON,
    ProjectModelFromJSONTyped,
    ProjectModelToJSON,
} from './ProjectModel';

/**
 *
 * @export
 * @interface ResponseGetProjectApiV1ProjectsProjectGet
 */
export interface ResponseGetProjectApiV1ProjectsProjectGet {
    /**
     *
     * @type {any}
     * @memberof ResponseGetProjectApiV1ProjectsProjectGet
     */
    id: any | null;
    /**
     *
     * @type {any}
     * @memberof ResponseGetProjectApiV1ProjectsProjectGet
     */
    title: any | null;
    /**
     *
     * @type {any}
     * @memberof ResponseGetProjectApiV1ProjectsProjectGet
     */
    content: any | null;
    /**
     *
     * @type {any}
     * @memberof ResponseGetProjectApiV1ProjectsProjectGet
     */
    type: any | null;
    /**
     *
     * @type {any}
     * @memberof ResponseGetProjectApiV1ProjectsProjectGet
     */
    author: any | null;
    /**
     *
     * @type {any}
     * @memberof ResponseGetProjectApiV1ProjectsProjectGet
     */
    publishOn: any | null;
    /**
     *
     * @type {FileUrl}
     * @memberof ResponseGetProjectApiV1ProjectsProjectGet
     */
    fileUrl?: FileUrl;
}

/**
 * Check if a given object implements the ResponseGetProjectApiV1ProjectsProjectGet interface.
 */
export function instanceOfResponseGetProjectApiV1ProjectsProjectGet(value: object): boolean {
    if (!('id' in value)) return false;
    if (!('title' in value)) return false;
    if (!('content' in value)) return false;
    if (!('type' in value)) return false;
    if (!('author' in value)) return false;
    if (!('publishOn' in value)) return false;
    return true;
}

export function ResponseGetProjectApiV1ProjectsProjectGetFromJSON(
    json: any,
): ResponseGetProjectApiV1ProjectsProjectGet {
    return ResponseGetProjectApiV1ProjectsProjectGetFromJSONTyped(json, false);
}

export function ResponseGetProjectApiV1ProjectsProjectGetFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ResponseGetProjectApiV1ProjectsProjectGet {
    if (json == null) {
        return json;
    }
    return {
        id: json['id'],
        title: json['title'],
        content: json['content'],
        type: json['type'],
        author: json['author'],
        publishOn: json['publish_on'],
        fileUrl: json['file_url'] == null ? undefined : FileUrlFromJSON(json['file_url']),
    };
}

export function ResponseGetProjectApiV1ProjectsProjectGetToJSON(
    value?: ResponseGetProjectApiV1ProjectsProjectGet | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        id: value['id'],
        title: value['title'],
        content: value['content'],
        type: value['type'],
        author: value['author'],
        publish_on: value['publishOn'],
        file_url: FileUrlToJSON(value['fileUrl']),
    };
}
